import { SettingsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { settingsChildrenFlatMap, useFilteredSettingsData } from 'modules/settings/lib/settings'

export const useSettings = () => {
  const { navigation } = useNavigation()
  const { company } = useCurrentSession()

  const { loading, data } = useQuery(SettingsPageDocument, {
    variables: { companyId: company.id },
  })

  const seeAllSettingsPages = data?.apiCore?._policies.seeAllSettingsPages.can ?? false

  const settings = useFilteredSettingsData(
    navigation,
    data?.companies.moduleAvailabilities || [],
    data,
    seeAllSettingsPages
  ).map((setting) => {
    const sortedChildren = setting.children.sort((a, b) => a.title.localeCompare(b.title))
    return { ...setting, children: sortedChildren }
  })

  return {
    loading,
    settings,
    settingsChildren: settingsChildrenFlatMap(settings),
    seeAllSettingsPages,
  }
}
